import { UtilityService } from '@eforall/common';
import { GridColumn, buildColumn } from '@eforall/dashboard';
import { Course, LanguageId } from '@interfaces';
import { DomainDataService } from '../../../../../../services';

export function getColumns(util: UtilityService, domainDataService: DomainDataService) {
	const columns: GridColumn<Course, unknown>[] = [
		buildColumn(util, 'Id', row => row.courseVersionId, { header: 'Course Version Id', hidden: true }),
		buildColumn(util, 'Text', row => row.title, { header: 'Title', width: 80 }),
		buildColumn(util, 'Number', row => row.version, { header: 'Version', width: 60 }),
		buildColumn(util, 'Text', row => row.type, { header: 'Type' }),
		buildColumn(util, 'Text', row => row.description, { header: 'Description', width: 120 }),
		buildColumn(util, 'Text', row => row.enrollmentStatus, { header: 'Enrollment Status', width: 100 }),
		buildColumn(util, 'Date', row => util.date.fromUTC(row.createdUTC), { header: 'Created On', width: 120 }),
		buildColumn(util, 'Date', row => util.date.fromUTC(row.updatedUTC), { header: 'Updated On', width: 120 }),
		buildColumn(util, 'Text', row => row.selfEnrollable, { header: 'Self Enrollable', width: 100, hidden: true }),
		buildColumn(util, 'Text', row => row.programName, { header: 'Program Name', width: 100, hidden: true }),
		buildColumn(util, 'Text', row => row.languageId === LanguageId.English ? 'English' : 'Spanish', { header: 'Language Id', width: 80, hidden: true }),
		buildColumn(util, 'Number', row => row.totalEnrollments, { header: 'Total Enrollments', width: 80, hidden: true }),
		buildColumn(util, 'Number', row => row.completedEnrollments, { header: 'Completed Enrollments', width: 100, hidden: true }),
	];
	return columns;
}